import React, { useContext } from 'react';

import { mdiDotsHorizontal } from '@mdi/js';
import Icon from '@mdi/react';
import { Button, Menu, MenuItem, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { RosterContext } from '../../../RosterContext';
import { ActionsTableCell, StyledTableCell } from '../../../styles/table-styles';

const StyledTableRow = styled(TableRow)`
    padding: 2rem;
`;

const MenuIcon = styled(Icon)`
    max-width: 35px;
    color: ${(props) => props.theme.colors.primary.main};
    height: 32px;
`;

export interface StudentTableRowProps {
    student: any;
}

const StudentTableRow: React.FC<StudentTableRowProps> = ({ student }) => {
    const { t } = useTranslation('roster');
    const { setOpenEditModal, setOpenDeleteModal, setSelectedStudentId } = useContext(RosterContext);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = (id) => {
        setSelectedStudentId(id);
        setOpenEditModal(true);

        handleClose();
    };

    const handleDelete = (id) => {
        setSelectedStudentId(id);
        setOpenDeleteModal(true);

        handleClose();
    };

    return (
        <StyledTableRow>
            <StyledTableCell>{student.user_name}</StyledTableCell>
            <StyledTableCell>{student.email}</StyledTableCell>
            <StyledTableCell>{t(`roles.${student.role}`)}</StyledTableCell>
            <ActionsTableCell>
                <Button id="student-actions" size={'small'} onClick={handleClick}>
                    <MenuIcon path={mdiDotsHorizontal} />
                </Button>
            </ActionsTableCell>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'student-action-button' }}
            >
                <MenuItem onClick={() => handleEdit(student.student_id)}>{t('Edit')}</MenuItem>
                <MenuItem onClick={() => handleDelete(student.student_id)}>{t('Delete')}</MenuItem>
            </Menu>
        </StyledTableRow>
    );
};

export default StudentTableRow;
